// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_yKY","cls2":"ExportFormatModal-cls2__5O ExportFormatModal-cls1_yKY"};